/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items listed in more than one column are counted in the overlap.`)
};

const es_venn_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los elementos listados en más de una columna se cuentan en la superposición.`)
};

const de_venn_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elemente, die in mehr als einer Spalte aufgeführt sind, werden in der Überschneidung gezählt.`)
};

const nl_venn_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items die in meer dan één kolom voorkomen, worden geteld in de overlap.`)
};

const fr_venn_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les éléments listés dans plus d'une colonne sont comptés dans le chevauchement.`)
};

const it_venn_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli elementi elencati in più di una colonna vengono contati nella sovrapposizione.`)
};

const pt_br2_venn_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itens listados em mais de uma coluna são contados na sobreposição.`)
};

const pt_venn_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os itens listados em mais do que uma coluna são contados na sobreposição.`)
};

const ja_venn_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複数の列に記載されている項目は、重なり部分としてカウントされます。`)
};

const zh_venn_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出现在多个列中的项目会被计入重叠区域。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_ex3", locale)
	if (locale === "en") return en_venn_ex3(inputs)
	if (locale === "es") return es_venn_ex3(inputs)
	if (locale === "de") return de_venn_ex3(inputs)
	if (locale === "nl") return nl_venn_ex3(inputs)
	if (locale === "fr") return fr_venn_ex3(inputs)
	if (locale === "it") return it_venn_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_venn_ex3(inputs)
	if (locale === "pt") return pt_venn_ex3(inputs)
	if (locale === "ja") return ja_venn_ex3(inputs)
	return zh_venn_ex3(inputs)
};